<template>
    <transition appear name="fade-transition">
        <div :class="classList">
            <v-textarea
                ref="input"
                v-model="inputValue"
                v-test-id
                class="edit__paragraph__input"
                :name="name || uuid"
                rows="3"
                auto-grow
                outlined
                dense
                :rules="validators"
                :label="label"
                :hint="hint"
                :description="description"
                background-color="background"
                color="primaryText"
                :hide-details="hideDetails || (!form && _.isEmpty(validators))"
                :disabled="disabled"
                :loading="loading"
                :readonly="readonly"
                :autocomplete="autocomplete ? 'on' : 'off'"
                :error="error"
                :error-messages="errorMessages"
                @focus="$emit('focus', inputValue)"
                @blur="$emit('blur', inputValue)"
                @keyup="$emit('keyup', inputValue)"
                @keydown="$emit('keydown', inputValue)"
                @click="$emit('click', inputValue)"
            />
        </div>
    </transition>
</template>

<script>
import Edit from './Edit';

export default {
    name: 'EditParagraph',
    extends: Edit
};
</script>

<style lang="scss">
.v-application .edit__paragraph {
    min-width: 7rem;
    &__input {
        font-size: 1rem;
    }
}
</style>
